import React from 'react'
import { INFDetailFormatted } from '../../components/NFTDetail/INFTDetail'
import NFTImageSkeleton from '../../components/NFTImageSkeleton'
import BaseDetail from './BaseDetail'


export default function SkiptNFTDetail(props: INFDetailFormatted) {
  const { tokenItem, collection } = props
  const tokenName = `${collection.name} Page:${tokenItem.tokenId}`

  return (
    <BaseDetail {...props} tokenItemName={tokenName}>
      {tokenItem && tokenItem.tokenUri ? (
        <img src={tokenItem.tokenUri.replace('ipfs://', 'https://ipfs.io/ipfs/')} alt={tokenName} />
      ) : (
        <NFTImageSkeleton />
      )}
    </BaseDetail>
  )
}
